import { render, staticRenderFns } from "./NavigationView.vue?vue&type=template&id=476b6c97&scoped=true&"
import script from "./NavigationView.vue?vue&type=script&lang=js&"
export * from "./NavigationView.vue?vue&type=script&lang=js&"
import style0 from "./NavigationView.vue?vue&type=style&index=0&id=476b6c97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476b6c97",
  null
  
)

export default component.exports